<div class="modal-header">
  <button type="button" class="btn-close mx-2" data-bs-dismiss="modal" aria-label="Close"></button>
  <div class="ms-2">
    @if (!data?.berthVisitSelection) {
      <span class="page-title">New Bunkering</span>
    }
    @if (data?.berthVisitSelection) {
      <span class="page-title">{{ data.berthVisitSelection.vesselName }}</span>
      @if (data.cancelled) {
        <span class="page-title cancelled">(CANCELLED)</span>
      }
      <br/>
      <span class="regular-caps-12-16">{{ data.berthVisitSelection.berthName }}</span>
    }
  </div>
</div>

<div class="modal-body">
  <div class="card">
    <div class="card-body">
      <div class="d-flex justify-content-between">
        <h5 class="header-1">Bunkering details</h5>
        @if (appContext.isAdmin()) {
          <div class="dropdown always-enabled">
            <button class="btn btn-outline-secondary" type="button" id="adminHamburgerMenu" data-bs-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false">
              <!-- Hamburger menu icon -->
              <i class="fa fa-user-shield" aria-hidden="true"></i>
            </button>
            <div class="dropdown-menu dropdown-menu-end" aria-labelledby="adminHamburgerMenu">
              <!-- Messages -->
              <h6 class="dropdown-header" style="font-size: 18px;">Messages</h6>
              <a href="#" (click)="$event.preventDefault(); openMessages()" class="dropdown-item">
                PRO to Singlewindow
              </a>
            </div>
          </div>
        }
      </div>

      @if (!data.input.license) {
        <app-form-field label="Service vessel">
          <app-search [(ngModel)]="data.input.license"
                      [searchFunction]="licences"
                      [resultFormatter]="formatLicense"
                      (ngModelChange)="saveLicense($event)"
                      required placeholder="Ship name or ENI"></app-search>
        </app-form-field>
      } @else {
        <div class="label">Service vessel *</div>
        <div class="card form-group  mb-3">
          <div class="card-body small py-2">
            <app-selection-license [selection]="data.input.license"></app-selection-license>
            <button type="button" class="btn btn-tertiary p-0" style="position: absolute; right: 0.75rem; top: 0.5rem"
                    (click)="data.input.license = undefined">
              @if (data.draft) {
                <i class="fa fa-light fa-edit"></i>
              }
            </button>
          </div>
        </div>
      }

      @if (!data.berthVisitSelection) {
        @if (data.input.license) {
          <app-form-field label="Visit">
            <app-search [(ngModel)]="data.berthVisitSelection"
                        [searchFunction]="getBerthVisitsFn()"
                        [resultFormatter]="formatGetBerthVisitsSelection"
                        required placeholder="Ship name or IMO"></app-search>
          </app-form-field>
        }
      } @else {
        <div class="label">Visit *</div>
        <div class="card form-group mb-3">
          <div class="card-body small py-2">
            <app-selection-bunkering-berth-visits [selection]="data.berthVisitSelection">
            </app-selection-bunkering-berth-visits>
            <button type="button" class="btn btn-tertiary p-0" style="position: absolute; right: 0.75rem; top: 0.5rem"
                    (click)="data.berthVisitSelection = undefined">
              @if (data.draft) {
                <i class="fa fa-light fa-edit"></i>
              }
            </button>
          </div>
        </div>
      }

      <div class="row">
        <app-form-field label="Supplier" class="col-md-6">
          <app-search [(ngModel)]="data.input.supplier"
                      [searchFunction]="suppliers"
                      [resultFormatter]="formatSupplier"
                      [inputFormatter]="formatSupplier"
                      [disabled]=!data.draft
                      required placeholder="Supplier name"></app-search>
        </app-form-field>
        <div class="col-6">
        </div>
      </div>

      <div class="row">
        <app-form-field label="Estimated start date and time" class="col-md-6">
          <app-new-date-field [(ngModel)]="data.input.ets" [disabled]="data.cancelled" required></app-new-date-field>
        </app-form-field>
      </div>
      @if (showEtsBeforeWindowWarning()) {
        <div class="alert alert-warning show row align-items-center" role="alert">
          <div class="col-1 ps-2">
            <i class="fa fa-light fa-circle-exclamation" aria-hidden="true" style="font-size: xxx-large"></i>
          </div>
          <div class="col-11">
            <b>Planning mismatch.</b><br/>
            Your ETS is before the ETA of the vessel.<br>
            You will probably not be able to start bunkering.<br>
          </div>
        </div>
      }
      <div class="row mb-md-2">
        <app-form-field label="Completion date and time" class="col-md-6">
          <app-new-date-field [(ngModel)]="completionTime" [disabled]=data.cancelled [byTheMinute]="!expectedTime"
                              required></app-new-date-field>
        </app-form-field>
        <app-yes-no class="col-md-6 mt-md-5 mb-4 pt-md-1" [(ngModel)]="expectedTime" [formatter]="formatExpectedTime"
                    required></app-yes-no>
      </div>

      @if (showEtcAfterWindowWarning()) {
        <div class="alert alert-warning show row align-items-center mx-0 mb-4" role="alert">
          <div class="col-3 col-sm-2 col-md-1 ps-2 text-center">
            <i class="fa fa-light fa-circle-exclamation warning-icon" aria-hidden="true"></i>
          </div>
          <div class="col-9 col-sm-10 col-md-11">
            <b>Planning mismatch.</b><br/>
            Your ETC is after the ETD of the vessel.<br>
            You are causing a delay for the departing vessel!<br/>
            Please leave the vessel in time or contact the ship’s agent.<br>
          </div>
        </div>
      }
      @if (showEtcWithin30MinutesWarning()) {
        <div class="alert alert-warning show row align-items-center mx-0 mb-4" role="alert">
          <div class="col-3 col-sm-2 col-md-1 ps-2 text-center">
            <i class="fa fa-light fa-circle-exclamation warning-icon" aria-hidden="true"></i>
          </div>
          <div class="col-9 col-sm-10 col-md-11">
            <b>Planning mismatch.</b><br/>
            Your ETC is less than 30 minutes before or equal to the ETD of the vessel.<br>
            You may cause a delay for the departing vessel!<br/>
          </div>
        </div>
      }
      @if (showInvalidPeriodWarning()) {
        <div class="alert alert-warning show row align-items-center mx-0 mb-4" role="alert">
          <div class="col-3 col-sm-2 col-md-1 ps-2 text-center">
            <i class="fa fa-light fa-circle-exclamation warning-icon" aria-hidden="true"></i>
          </div>
          <div class="col-9 col-sm-10 col-md-11">
            <b>Start/completion time mismatch.</b><br/>
            The completion time should be after the start time.
          </div>
        </div>
      }
      @if (showAtcInTheFutureWarning()) {
        <div class="alert alert-warning show row align-items-center mx-0 mb-4" role="alert">
          <div class="col-3 col-sm-2 col-md-1 ps-2 text-center">
            <i class="fa fa-light fa-circle-exclamation warning-icon" aria-hidden="true"></i>
          </div>
          <div class="col-9 col-sm-10 col-md-11">
            <b>Actual time of completion is in the future.</b><br/>
            Report the ATC when the bunkering is actually completed.
          </div>
        </div>
      }

      @for (item of data.input.items; track item; let i = $index) {
        <div class="row mb-5 gy-3">
          <div class="col-md-6">
            <div class="mb-2">Product</div>
            <app-search [(ngModel)]="item.product"
                        [searchFunction]="products"
                        [resultFormatter]="formatProduct"
                        [inputFormatter]="formatProduct"
                        [disabled]=data.cancelled
                        required placeholder="Product type"></app-search>
          </div>
          <div class="col-md-2 col-4">
            <div class="mb-2">Quantity</div>
            <input appDecimalNumber [maxDecimals]="0" [min]="0" [(ngModel)]="item.quantity" [disabled]=data.cancelled
                   class="form-control" required>
          </div>
          <div class="col-md-2 col-4">
            <div class="mb-3 pb-1">Units</div>
            {{ item.product?.unitOfMeasure }}
          </div>
          <div class="col-md-2 col-4 d-flex justify-content-end align-items-end pb-1">
            @if (data.input.items.length > 1) {
              <button type="button" class="btn btn-tertiary p-0" (click)="deleteItem(i);"
                      [disabled]=data.cancelled><i class="fa fa-light fa-trash-can fs-5"></i>
              </button>
            }
          </div>
        </div>
      }

      <div class="my-2 text-end">
        <button type="submit" class="btn btn-outline-secondary" style="min-width: 10rem"
                (click)="addProduct()" [disabled]=data.cancelled>
          <i class="fal fa-plus me-2"></i> Add Product
        </button>
      </div>

      <hr/>
      <ng-container>
        <div class="row">
          <app-form-group label="Report to customs?" class="col-12">
            <app-yes-no [disabled]="!data.draft" required [(ngModel)]="data.sendProToCustoms"
                        id="sendToCustoms"></app-yes-no>
          </app-form-group>
        </div>
      </ng-container>
    </div>
  </div>
</div>

@if (!data.cancelled) {
  <div class="modal-footer">
    <div class="footer-container" style="display: inline;">
      @if (!data.draft) {
        <button type="button" class="btn btn-outline-danger float-start footer-button"
                (click)="cancel()">
          Cancel bunkering
        </button>
      }
      <div class="float-end">
        <button type="button" class="btn btn-outline-secondary me-3 footer-button" (click)="close()">Cancel
        </button>
        <button type="button" class="btn btn-primary footer-button" (click)="submit()">Send
        </button>
      </div>
    </div>
  </div>
}
